import React, { Component } from 'react';
import { Header, Tab, Message } from 'semantic-ui-react';

import withRequireLogin from '../../HOCs/withRequireLogin';
import { BallLoader } from '../General/BallLoader';
import axios from '../../util/CustomAxios';
import ProductListTable from './Presenter/ProductListTable';
import RetailPriceTable from './Presenter/RetailPriceTable';

class ProductPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      products: [],
      isLoading: true,
      error: null,
    };
  }

  async componentDidMount() {
    try {
      const response = await axios.get('/Products');
      this.setState({ products: response.data, isLoading: false });
    } catch (error) {
      console.log(error);
      this.setState({
        isLoading: false,
        error: '제품 데이터를 불러오는 중 오류가 발생했습니다.',
      });
    }
  }

  render() {
    const { products, isLoading, error } = this.state;

    const panes = [
      {
        menuItem: 'Products',
        render: () => (
          <Tab.Pane>
            <ProductListTable data={products} />
          </Tab.Pane>
        ),
      },
      {
        menuItem: '지역별 소매가격 (Retail Prices)',
        render: () => (
          <Tab.Pane>
            <RetailPriceTable data={products} />
          </Tab.Pane>
        ),
      },
    ];

    return (
      <div style={{ width: '90vw', margin: '0 auto' }}>
        <Header as="h1" dividing>
          Product/Price
        </Header>
        <br />
        {isLoading ? (
          <BallLoader />
        ) : error ? (
          <Message negative content={error} />
        ) : (
          <Tab panes={panes} />
        )}
      </div>
    );
  }
}

export default withRequireLogin(ProductPage);
